import { WIDGET_TIMEOUT, YF_STORAGE_REMAINING_TIMEOUT, YF_STORAGE_START_TIME } from './constants'

export function saveRemainingTimeoutToStorage () {
  const startTime = window.sessionStorage.getItem(YF_STORAGE_START_TIME)
  const remainingTimeout = Math.max(WIDGET_TIMEOUT - (new Date().getTime() - startTime), 0)
  if (remainingTimeout > 0) {
    window.sessionStorage.setItem(YF_STORAGE_REMAINING_TIMEOUT, remainingTimeout)
  }
  window.sessionStorage.removeItem(YF_STORAGE_START_TIME)
  window.removeEventListener('unload', saveRemainingTimeoutToStorage)
}
